// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_24fzA","header":"xmIQc","ok-button":"_3rU7Z","okButton":"_3rU7Z","sub-footer":"_25Gay","subFooter":"_25Gay"};